import { NgClass } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { CustomInputComponent } from 'components/input/custom-input/custom-input.component';
import { SubmitButtonComponent } from 'components/input/submit-button/submit-button.component';
import { CredentialType } from 'enums/CredentialType';
import { MessageType } from 'enums/MessageType';
import { ReasonModel } from 'models/generated/Entities.GormCrm.Reason';
import { ReasonCategoryModel } from 'models/generated/Entities.GormCrm.ReasonCategory';
import { SelectListItemModel } from 'models/SelectList';
import { Layout } from 'modules/layout';
import { ListView } from 'modules/list-view';
import { TranslatePipe } from 'pipes/translate.pipe';
import { Subscription } from 'rxjs';
import { CredentialRequired } from 'services/credential.service';
import { FormValidationService } from 'services/form-validation.service';
import { NotificationService } from 'services/notification.service';
import { PushService } from 'services/push.service';
import { ReasonService } from 'services/reason.service';

@Component({
	selector: 'list-reason-categories',
	templateUrl: './list-reason-categories.component.html',
	providers: [FormValidationService],
	imports: [Layout, CustomInputComponent, ListView, NgClass, TranslatePipe]
})
@CredentialRequired(CredentialType.EditReasons)
export class ListReasonCategoriesComponent {

	@ViewChild('saveButton') saveButton!: SubmitButtonComponent;

	public reasonCategory: ReasonCategoryModel = new ReasonCategoryModel();
	public selectedReasonCategory: ReasonCategoryModel = new ReasonCategoryModel();
	public reasonCategories: ReasonCategoryModel[] = [];
	public selectReasonCategories: SelectListItemModel[] = [];
	reasons: ReasonModel[] = [];
	onReasonCategoryChanges: Subscription;

	constructor(private readonly pushService: PushService,
		private readonly reasonService: ReasonService,
		private readonly notificationService: NotificationService) {

		this.updateReasonCategoryList();
		this.onReasonCategoryChanges = this.pushService.onChanges(MessageType.ReasonCategoryChanges).subscribe(_ => this.updateReasonCategoryList());
	}

	updateReasonCategoryList() {
		this.reasonService.getAllReasonCategories().then((trt) => this.reasonCategories = trt.sort((a, b) => a.name.localeCompare(b.name)));
		this.reasonService.getAllReasons().then((tr) => this.reasons = tr);
	}

	selectReasonCategory(category: ReasonCategoryModel) {
		this.selectedReasonCategory = category;
		Object.assign(this.reasonCategory, category);
	}

	canDelete(terminatonReasonCategory: ReasonCategoryModel) {
		return !this.reasons.some(tr => tr.categoryId === terminatonReasonCategory.id);
	}

	deleteReasonCategory(category: ReasonCategoryModel) {
		if (!this.canDelete(category)) return;
		this.notificationService.confirm('reason.reason-categories.prompt-for-delete', { 'reasonCategoryName': category.name }).subscribe(result => {
			if (result)
				this.reasonService.deleteReasonCategory(category.id!).then(_ => this.selectedReasonCategory = new ReasonCategoryModel());
		});
	}

	save() {
		this.reasonService.saveReasonCategory(this.reasonCategory).then(_ => this.saveButton.succeeded());
	}
}
